<template>
  <PaymentDetailsTypeSwitch :paymentDetail="billsPayment" />
</template>

<script>
import paymentDetailsCommonMethods from './paymentDetailsCommonMethods.js';
import AccountApi from '@/services/AccountApi';
import PaymentDetailsTypeSwitch  from './PaymentDetailsTypeSwitch.vue';
import { Presets } from '@/models/Presets';
import { BillsPaymentDetail } from '@/models/BillsPaymentDetail';

export default {
  name: 'AppDetailsBillsPayment',
  mixins: [paymentDetailsCommonMethods],
  components: {
    PaymentDetailsTypeSwitch,
  },
  data() {
    return {
      billsPayment: new BillsPaymentDetail(),
      preset: new Presets(),
    };
  },
  async mounted() {
    await this.presets();
    const rawPayment = this.$route.params.payment;
    this.billsPayment = this.mapToBillsPaymentDetail(rawPayment);
  },
  methods: {
    async presets() {
      const api = new AccountApi();
      this.preset = await api.presets();
    },
    mapToBillsPaymentDetail(data) {
      const detail = new BillsPaymentDetail();
      detail.barCode = data.barCode || '';
      detail.recipientName = data.recipientName || '';
      detail.recipientDocument = data.recipientDocument || '';
      detail.finalRecipientName = data.finalRecipientName || '';
      detail.finalRecipientDocument = data.finalRecipientDocument || '';
      detail.description = data.description || '';
      detail.protocolId = data.protocolId || '';
      detail.value = data.value || 0;
      detail.valuePaid = data.valuePaid || 0;
      detail.penalty = data.penalty || 0;
      detail.discount = data.discount || 0;
      detail.createdAt = data.createdAt || '';
      detail.status = data.status || '';
      detail.paymentDate = data.paymentDate || '';
      detail.canceledDate = data.canceledDate || '';
      detail.rejectedDate = data.rejectedDate || '';
      detail.chargebackAt = data.chargebackAt || '';
      detail.dueDate = data.dueDate || '';
      detail.details = Array.isArray(data.details) ? data.details : [];
      detail.preset = {
        holder: {
          fullName: this.preset.holder.fullName,
        },
        bankAccount: {
          accountNumber: this.preset.bankAccount.accountNumber,
          bankBranchNumber: this.preset.bankAccount.bankBranchNumber,
        },
      };
      return detail;
    },
  },
};
</script>
